// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: letter landscape;
  margin: 0.25in;
}
:host {
  display: block;
  min-height: 100vh;
  background: white;
}

.pdf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 8px 16px;
  border-bottom: 0.5px solid #d6d6d6;
  background: #f7f7f7;
}

.pdf-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.pdf-preview {
  display: block;
  width: 100%;
  height: calc(100vh - 53px);
  border: 0;
  background: #525659;
}

.progress-spinner {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.message-state {
  padding: 24px;
  color: #666;
}

.container.album {
  box-sizing: border-box;
  width: 8in;
  max-width: 8in;
  margin: 0 auto 30px;
  font-family: sans-serif;
  font-size: 9pt;
}

.worksheet-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
}

.worksheet-header::after {
  content: "";
  flex: 0 0 40px;
}

.worksheet-header .logo {
  width: 40px;
  object-fit: contain;
  flex: 0 0 40px;
}

.worksheet-header > .text-center {
  flex: 1 1 auto;
  min-width: 0;
}

.worksheet-header h2,
.worksheet-header h5 {
  margin: 0;
}

.worksheet-header h2 {
  font-size: 2.25rem;
  font-weight: bold;
}

.worksheet-header h5 {
  font-size: 3.5rem;
  font-weight: normal;
}

.worksheet-details {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.worksheet-job-info {
  flex: 0 1 auto;
  margin-right: auto;
}

.worksheet-summary {
  display: grid;
  flex: 0 0 auto;
  grid-template-rows: repeat(5, 20px);
  min-width: 250px;
  align-items: center;
  margin: 3px 0;
}

.worksheet-summary-date {
  grid-row: 1;
}

.worksheet-summary-density {
  grid-row: 4;
}

.worksheet-summary-yp {
  grid-row: 5;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.nobr {
  white-space: nowrap;
}

.wide {
  width: auto;
}

.width100 {
  width: 100%;
}

.width1 {
  width: 1%;
}

.width15 {
  width: 15px;
}

.width20 {
  width: 20px;
}

.width60 {
  width: 60px;
}

.width75 {
  width: 75px;
}

.width100px {
  width: 100px;
}

.worksheet-design-column {
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  box-sizing: border-box;
}

.worksheet-narrow-column {
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

table.printable th.worksheet-design-column strong {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.no-border {
  border: 0 !important;
}

.pale {
  background-color: #eeeeee !important;
}

.dark-pale {
  background-color: #feffa4 !important;
}

.light-pale {
  background-color: #feffd8 !important;
}

.divider {
  background-color: #cccccc !important;
}

table.wide {
  width: 730px;
}

.brine-formulation-table {
  width: 320px !important;
  margin-top: 12px !important;
}

table.printable {
  width: auto;
  font-size: 9pt;
  border-spacing: 0;
  border-style: solid;
  border-color: black;
  border-collapse: collapse;
  margin: 3px 0;
  page-break-inside: avoid;
}
table.printable th,
table.printable td {
  border-width: 0.5px;
  padding: 0 3px;
  line-height: 1.1;
  border-style: solid;
  border-color: black;
  page-break-inside: avoid;
  height: 20px;
  max-height: 20px;
  vertical-align: middle;
}

table caption {
  padding: 0;
}

.container.album.pdf-capture {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}
.container.album.pdf-capture * {
  font-size: 6pt;
}
.container.album.pdf-capture h2 {
  font-size: 1rem;
}
.container.album.pdf-capture h5 {
  font-size: 0.8rem;
}
.container.album.pdf-capture .dark-pale {
  background-color: #feffa4 !important;
}
.container.album.pdf-capture .light-pale {
  background-color: #feffd8 !important;
}
.container.album.pdf-capture .no-print {
  display: none !important;
}

@media print {
  :host {
    background: white;
  }
  .container.album {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
  .container.album * {
    font-size: 6pt;
  }
  .container.album h2 {
    font-size: 1rem;
  }
  .container.album h5 {
    font-size: 0.8rem;
  }
  .container.album .dark-pale {
    background-color: #feffa4 !important;
  }
  .container.album .light-pale {
    background-color: #feffd8 !important;
  }
  .container.album .no-print {
    display: none !important;
  }
}
:host ::ng-deep table.printable th,
:host ::ng-deep table.printable td,
:host ::ng-deep .container.album table.printable th,
:host ::ng-deep .container.album table.printable td {
  font-size: 6px !important;
}

:host ::ng-deep .next-page,
:host ::ng-deep .nextpage {
  font-size: 10px !important;
}

@media (max-width: 720px) {
  .worksheet-details {
    flex-direction: column;
    gap: 8px;
  }
  .worksheet-summary {
    width: 100%;
    min-width: 0;
    grid-template-rows: none;
    gap: 4px;
    margin-top: 0;
  }
  .worksheet-summary-date,
  .worksheet-summary-density,
  .worksheet-summary-yp {
    grid-row: auto;
  }
  .pdf-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-preview {
    height: calc(100vh - 105px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-work-sheet/job-request-work-sheet.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,cAAA;AACF;AAEA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,QAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,sBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,YAAA;AAAF;;AAGA;;EAEE,SAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EAA0B,WAAA;AAC1B;;AAAA;EAA6B,WAAA;AAI7B;;AAHA;EAAwB,WAAA;AAOxB;;AALA;EAAe,kBAAA;AASf;;AARA;EAAc,iBAAA;AAYd;;AAXA;EAAa,gBAAA;AAeb;;AAdA;EAAQ,mBAAA;AAkBR;;AAjBA;EAAQ,WAAA;AAqBR;;AApBA;EAAY,WAAA;AAwBZ;;AAvBA;EAAU,SAAA;AA2BV;;AA1BA;EAAW,WAAA;AA8BX;;AA7BA;EAAW,WAAA;AAiCX;;AAhCA;EAAW,WAAA;AAoCX;;AAnCA;EAAW,WAAA;AAuCX;;AAtCA;EAAc,YAAA;AA0Cd;;AAzCA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AA4CF;;AAzCA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA4CF;;AAzCA;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA4CF;;AAzCA;EAAa,oBAAA;AA6Cb;;AA5CA;EAAQ,oCAAA;AAgDR;;AA/CA;EAAa,oCAAA;AAmDb;;AAlDA;EAAc,oCAAA;AAsDd;;AArDA;EAAW,oCAAA;AAyDX;;AAvDA;EAAa,YAAA;AA2Db;;AAzDA;EACE,uBAAA;EACA,2BAAA;AA4DF;;AAzDA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;AA4DF;AA1DE;;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AA4DJ;;AAxDA;EAAgB,UAAA;AA4DhB;;AA5CA;EAbE,WAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AA6DF;AA3DE;EAAM,cAAA;AA8DR;AA7DE;EAAO,eAAA;AAgET;AA/DE;EAAO,iBAAA;AAkET;AAjEE;EAAe,oCAAA;AAoEjB;AAnEE;EAAgB,oCAAA;AAsElB;AArEE;EAAc,wBAAA;AAwEhB;;AAjEA;EACE;IAAQ,iBAAA;EAqER;EAnEA;IApBA,WAAA;IACA,eAAA;IACA,SAAA;IACA,UAAA;EA0FA;EAxFA;IAAM,cAAA;EA2FN;EA1FA;IAAO,eAAA;EA6FP;EA5FA;IAAO,iBAAA;EA+FP;EA9FA;IAAe,oCAAA;EAiGf;EAhGA;IAAgB,oCAAA;EAmGhB;EAlGA;IAAc,wBAAA;EAqGd;AACF;AAtFA;;;;EAIE,yBAAA;AAwFF;;AArFA;;EAEE,0BAAA;AAwFF;;AArFA;EACE;IACE,sBAAA;IACA,QAAA;EAwFF;EArFA;IACE,WAAA;IACA,YAAA;IACA,wBAAA;IACA,QAAA;IACA,aAAA;EAuFF;EApFA;;;IAGE,cAAA;EAsFF;EAnFA;IACE,uBAAA;IACA,sBAAA;EAqFF;EAlFA;IACE,2BAAA;EAoFF;AACF","sourcesContent":["@page {\n  size: letter landscape;\n  margin: 0.25in;\n}\n\n:host {\n  display: block;\n  min-height: 100vh;\n  background: white;\n}\n\n.pdf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  min-height: 52px;\n  padding: 8px 16px;\n  border-bottom: 0.5px solid #d6d6d6;\n  background: #f7f7f7;\n}\n\n.pdf-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.pdf-preview {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 53px);\n  border: 0;\n  background: #525659;\n}\n\n.progress-spinner {\n  display: flex;\n  justify-content: center;\n  padding: 48px 0;\n}\n\n.message-state {\n  padding: 24px;\n  color: #666;\n}\n\n.container.album {\n  box-sizing: border-box;\n  width: 8in;\n  max-width: 8in;\n  margin: 0 auto 30px;\n  font-family: sans-serif;\n  font-size: 9pt;\n}\n\n.worksheet-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 10px;\n}\n\n.worksheet-header::after {\n  content: '';\n  flex: 0 0 40px;\n}\n\n.worksheet-header .logo {\n  width: 40px;\n  object-fit: contain;\n  flex: 0 0 40px;\n}\n\n.worksheet-header > .text-center {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.worksheet-header h2,\n.worksheet-header h5 {\n  margin: 0;\n}\n\n.worksheet-header h2 {\n  font-size: 2.25rem;\n  font-weight: bold;\n}\n\n.worksheet-header h5 {\n  font-size: 3.5rem;\n  font-weight: normal;\n}\n\n.worksheet-details {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.worksheet-job-info {\n  flex: 0 1 auto;\n  margin-right: auto;\n}\n\n.worksheet-summary {\n  display: grid;\n  flex: 0 0 auto;\n  grid-template-rows: repeat(5, 20px);\n  min-width: 250px;\n  align-items: center;\n  margin: 3px 0;\n}\n\n.worksheet-summary-date { grid-row: 1; }\n.worksheet-summary-density { grid-row: 4; }\n.worksheet-summary-yp { grid-row: 5; }\n\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.text-left { text-align: left; }\n.nobr { white-space: nowrap; }\n.wide { width: auto; }\n.width100 { width: 100%; }\n.width1 { width: 1%; }\n.width15 { width: 15px; }\n.width20 { width: 20px; }\n.width60 { width: 60px; }\n.width75 { width: 75px; }\n.width100px { width: 100px; }\n.worksheet-design-column {\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  box-sizing: border-box;\n}\n\n.worksheet-narrow-column {\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  box-sizing: border-box;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\ntable.printable th.worksheet-design-column strong {\n  display: block;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.no-border { border: 0 !important; }\n.pale { background-color: #eeeeee !important; }\n.dark-pale { background-color: #feffa4 !important; }\n.light-pale { background-color: #feffd8 !important; }\n.divider { background-color: #cccccc !important; }\n\ntable.wide { width: 730px; }\n\n.brine-formulation-table {\n  width: 320px !important;\n  margin-top: 12px !important;\n}\n\ntable.printable {\n  width: auto;\n  font-size: 9pt;\n  border-spacing: 0;\n  border-style: solid;\n  border-color: black;\n  border-collapse: collapse;\n  margin: 3px 0;\n  page-break-inside: avoid;\n\n  th,\n  td {\n    border-width: 0.5px;\n    padding: 0 3px;\n    line-height: 1.1;\n    border-style: solid;\n    border-color: black;\n    page-break-inside: avoid;\n    height: 20px;\n    max-height: 20px;\n    vertical-align: middle;\n  }\n}\n\ntable caption { padding: 0; }\n\n@mixin worksheet-print-layout {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  & * { font-size: 6pt; }\n  & h2 { font-size: 1rem; }\n  & h5 { font-size: 0.8rem; }\n  & .dark-pale { background-color: #feffa4 !important; }\n  & .light-pale { background-color: #feffd8 !important; }\n  & .no-print { display: none !important; }\n}\n\n.container.album.pdf-capture {\n  @include worksheet-print-layout;\n}\n\n@media print {\n  :host { background: white; }\n\n  .container.album {\n    @include worksheet-print-layout;\n  }\n\n}\n\n:host ::ng-deep table.printable th,\n:host ::ng-deep table.printable td,\n:host ::ng-deep .container.album table.printable th,\n:host ::ng-deep .container.album table.printable td {\n  font-size: 6px !important;\n}\n\n:host ::ng-deep .next-page,\n:host ::ng-deep .nextpage {\n  font-size: 10px !important;\n}\n\n@media (max-width: 720px) {\n  .worksheet-details {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .worksheet-summary {\n    width: 100%;\n    min-width: 0;\n    grid-template-rows: none;\n    gap: 4px;\n    margin-top: 0;\n  }\n\n  .worksheet-summary-date,\n  .worksheet-summary-density,\n  .worksheet-summary-yp {\n    grid-row: auto;\n  }\n\n  .pdf-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pdf-preview {\n    height: calc(100vh - 105px);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
